import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_service_details = _resolveComponent("service-details")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ion_spinner)
          ]))
        : (_openBlock(), _createBlock(_component_service_details, {
            key: 1,
            event: $setup.event,
            serviceId: $setup.event.serviceId,
            userId: $setup.userId,
            showActionBtns: $setup.showActions == '1',
            showUnsubscribePrompt: $setup.showUnsubscribePrompt,
            showApplyPrompt: $setup.showApplyPrompt,
            showConfirmPrompt: $setup.showConfirmPrompt,
            showWithdrawPrompt: $setup.showWithdrawPrompt,
            hideTeacherResponse: $setup.hideTeacherResponse
          }, null, 8, ["event", "serviceId", "userId", "showActionBtns", "showUnsubscribePrompt", "showApplyPrompt", "showConfirmPrompt", "showWithdrawPrompt", "hideTeacherResponse"]))
    ]),
    _: 1
  }))
}